import axios from 'axios'
import { ResponseObjectUpload } from '../../../models'
import { SchedulingActivityDto } from '../model/cleaningSchedule.model'
const BASEURL = process.env.REACT_APP_DEV_API_LIMPIEZA_URL

export const SCHEDULE_ACTIVITY_SERVICES = {
  assigningActivities: async (dto: SchedulingActivityDto) => {
    return await axios.post<ResponseObjectUpload>(`${BASEURL}/serviceScheduling/assigningActivities`, dto)
  },
  deleteActivitySettings: async (dto: SchedulingActivityDto) => {
    return await axios.post<ResponseObjectUpload>(`${BASEURL}/serviceScheduling/deleteActivitySettings`, dto)
  },
}
